<template>
  <div class="infoBanner">
    <div class="infoBanner__inner">
      <div class="infoBanner__wrapper">
        <div class="infoBanner__icon">
          <img :src="JSON.parse(data.Icon).url" alt="" class="infoBanner__iconImg" />
        </div>
        <div class="infoBanner__text" v-html="data.Text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBanner',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.infoBanner {
  position: relative;
  padding: 3rem 1rem 1rem;
  background-color: $cWhite;

  @include rwd('large-phone') {
    padding: 2rem;
  }

  &__inner {
    min-height: 13rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1026' height='130'%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath data-name='Rectangle 1890' fill='%23fff' d='M0 0h1026v130H0z'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Cpath data-name='Polygon 49' d='M255.861 14.314a15 15 0 0 1 23.277 0L515.11 304.537A15 15 0 0 1 503.471 329H31.528a15 15 0 0 1-11.638-24.463Z' fill='%23d5e2f9'/%3E%3C/clipPath%3E%3CclipPath id='c'%3E%3Cpath data-name='Polygon 52' d='M433.646 11.379a15 15 0 0 1 21.708 0l409.462 429.268A15 15 0 0 1 853.962 466H35.038a15 15 0 0 1-10.854-25.353Z' transform='rotate(180 444.5 233)' fill='%23eff3ff'/%3E%3C/clipPath%3E%3CclipPath id='d'%3E%3Cpath data-name='Polygon 51' d='M255.861 14.314a15 15 0 0 1 23.277 0L515.11 304.537A15 15 0 0 1 503.471 329H31.528a15 15 0 0 1-11.638-24.463Z' fill='%23d5e2f9'/%3E%3C/clipPath%3E%3CclipPath id='e'%3E%3Cpath data-name='Polygon 50' d='M366.857 14.335a15 15 0 0 1 23.286 0l346.992 427.208A15 15 0 0 1 725.492 466H31.508a15 15 0 0 1-11.643-24.457Z' transform='rotate(180 378.5 233)' fill='%23eff3ff'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Mask Group 37' clip-path='url(%23a)'%3E%3Cg data-name='Mask Group 53' transform='translate(-379.999 -137)' clip-path='url(%23b)'%3E%3Cpath data-name='Rectangle 3039' fill='%23d5e2f9' d='M342 28h500v346H342z'/%3E%3C/g%3E%3Cg data-name='Mask Group 55' transform='translate(187.999 97.998)' clip-path='url(%23c)'%3E%3Cpath data-name='Rectangle 3042' fill='%23eff3ff' d='M-119.998-207h955.997v346h-955.997z'/%3E%3C/g%3E%3Cg data-name='Group 22694' transform='translate(918.998 -137)' clip-path='url(%23d)'%3E%3Cpath data-name='Rectangle 3041' fill='%23d5e2f9' d='M-306.999 28h500v346h-500z'/%3E%3C/g%3E%3Cg data-name='Mask Group 54' transform='translate(-467 97.998)' clip-path='url(%23e)'%3E%3Cpath data-name='Rectangle 3040' fill='%23eff3ff' d='M455.998-207h500v346h-500z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-size: contain;
    background-position: bottom center;
    background-repeat: no-repeat;

    @include rwd('tablet') {
      background-size: cover;
      background-position: left;
    }

    @include rwd('large-phone') {
      background-image: none;
      min-height: unset;
    }
  }

  &__wrapper {
    position: relative;
    display: flex;
    padding: 0 2rem;
    top: -1rem;
    align-items: center;

    @include rwd('tablet') {
      position: static;
      top: unset;
    }

    @include rwd('large-phone') {
      padding: 0;
      flex-wrap: wrap;
    }
  }

  &__icon {
    display: flex;
    margin-right: 3.2rem;
    align-items: center;
    justify-content: center;
    flex: 0 0 8.8rem;
    max-width: 8.8rem;
    height: 8.8rem;
    background-color: $cBg;
    border-radius: 50%;
    box-shadow: 0 10px 20px rgba(#6b42ac, 0.2);

    @include rwd('large-tablet') {
      margin-right: 2.5rem;
    }

    @include rwd('tablet') {
      flex: 0 0 7.5rem;
      max-width: 7.5rem;
      height: 7.5rem;
    }

    @include rwd('large-phone') {
      margin-right: 2rem;
      flex: 0 0 6rem;
      max-width: 6rem;
      height: 6rem;
    }
  }

  &__iconImg {
    max-width: 6rem;
    height: auto;

    @include rwd('tablet') {
      max-width: 4.8rem;
    }

    @include rwd('large-phone') {
      max-width: 4rem;
    }
  }

  &__text {
    font-size: 2rem;
    font-weight: 600;
    line-height: 2.5rem;
    color: $cMainDark;
    max-width: 74rem;

    @include rwd('large-tablet') {
      font-size: 1.8rem;
      line-height: 2.2rem;
    }

    @include rwd('tablet') {
      font-size: 1.6rem;
      line-height: 2rem;
    }

    @include rwd('large-phone') {
      margin-top: 2rem;
      font-size: 1.4rem;
    }
  }
}
</style>
